module.exports = __webpack_public_path__ + "img/orgDetail_1_small.6b82a550.png";